import React, { useState, useEffect } from 'react';
import { useForm } from 'react-form';
import { useTranslation } from 'react-i18next';

import FeedbackInput from '../../components/FeedbackInput/FeedbackInput';
import FeedbackAutocomplete from '../../components/FeedbackAutocomplete/FeedbackAutocomplete';
import DateCalendarField from '../../components/DateCalendar/DateCalendarField';
import { isDefined } from '../../utils/utils';
import LoadingModal from '../../components/Loadings/LoadingModal';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import 'moment/locale/pt';
import 'moment/locale/en-gb';
import { enGB, pt } from 'date-fns/locale';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';

//ICONS
import PatientIcon from '../../utils/account-circle.svg';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

//CSS
import './PatientsInfoForm.scss';
import { TextField } from '@material-ui/core';

type onCloseFnType = (value: boolean) => String | false | undefined;
type savePatientFnType = (value: any) => String | false | undefined;
type onAddFnType = (value: any) => String | false | undefined;
type onChangeFnType = (
    type: string,
    id: number,
    value: any
) => String | false | undefined;
type onValidateFnType = () => boolean | undefined;
type onDeleteFnType = (valueEp: number, valueInt: number) => boolean | undefined;

interface IEpisodes {
    id: number;
    type: string;
    description: string;
    entrydate: Date;
    exitDate: Date | null;
    isClosed: boolean;
    room?: string;
    bed?: string;
    idIntern?: number;
    delete?: boolean;
}
interface IPatient {
    name: string;
    photoUri: string;
    identificationTypeId: number;
    identification: string;
    type: string;
    birthDate: Date;
    gender: string;
    career: string;
    nationality: string;
    clinicalHistory: string;
    episodes: IEpisodes[];
}

interface IIdentificationType {
    id: number;
    type: string;
    description: string;
}

const useStyles = makeStyles((theme) => ({
    hrEpisodes: {
        borderStyle: 'dashed',
        borderTopWidth: 1,
        borderColor: 'rgba(0, 0, 0, 0.1)',
        border: 0
    }
}));

const PatientsInfoForm = ({
    editMode,
    onClose,
    savePatient,
    patientInfo,
    scroll,
    descriptionElementRef,
    onAddEpisodeToPatient,
    saveInProgress,
    isLoading,
    onChangeEpisodesDate,
    identificationTypes,
    onDeleteEpisode
}: {
    editMode: boolean;
    onClose: onCloseFnType;
    savePatient: savePatientFnType;
    patientInfo: IPatient;
    scroll: String | undefined;
    descriptionElementRef: any;
    onAddEpisodeToPatient: onAddFnType;
    saveInProgress: boolean;
    isLoading: boolean;
    onChangeEpisodesDate: onChangeFnType;
    identificationTypes: IIdentificationType[];
    onDeleteEpisode: onDeleteFnType;
}) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const {
        Form, //reset,
        setFieldValue,
        meta: { isTouched, canSubmit, isValid }
    } = useForm({
        validate: (values: any, instance: any) => {
            //não podem haver vários episódios do mesmo tipo em aberto..
            let validation = true;

            /* if (editMode) {
                            let numEpisodes = listEpisodes.length;
                            for (let i = 0; i < numEpisodes; i++) {
                                let episode = listEpisodes[i];
                                console.log(episode);
                                if (!episode.isClosed) {
                                    for (let j = 0; j < numEpisodes; j++) {
                                        if (i !== j) {
                                            let episode2 = listEpisodes[j];
                                            console.log(episode2);
                                            if (isDefined(episode2)) {
                                                if (episode.type == episode2.type && !episode2.isClosed) {
                                                    validation = false;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                                if (!validation) {
                                    break;
                                }
                            }
                        } */

            return validation;
        },
        onSubmit: async (values: any, instance: any) => {
            let valuesEpisodes = values.episodes;
            let episodesOr = listEpisodes;
            //let episodesResult: IEpisodes[] = [];
            let episodesResult = listEpisodes;
            let numEpisodes = listEpisodes.length;

            if (editMode) {
                for (let i = 0; i < numEpisodes; i++) {
                    let ep = {
                        id: episodesOr[i].id,
                        type: episodesOr[i].type,
                        entrydate: episodesOr[i].entrydate,
                        exitDate: episodesOr[i].exitDate,
                        isClosed: episodesOr[i].isClosed,
                        description: valuesEpisodes[i].description,
                        bed: valuesEpisodes[i].bed,
                        room: valuesEpisodes[i].room,
                        idIntern: episodesOr[i].idIntern,
                        delete: episodesOr[i].delete
                    };
                    if (i == 0) {
                        episodesResult = [ep];
                    } else {
                        episodesResult = episodesResult.concat(ep);
                    }
                }
            } else {
                for (let i = 0; i < numEpisodes; i++) {
                    let ep = {
                        id: 0,
                        type: addField.type,
                        entrydate: episodesOr[i].entrydate,
                        exitDate: episodesOr[i].exitDate,
                        isClosed: episodesOr[i].isClosed,
                        description: valuesEpisodes[i].description,
                        bed: valuesEpisodes[i].bed,
                        room: valuesEpisodes[i].room
                    };
                    episodesResult = [ep];
                }
            }

            const valuesSave = {
                name: values.name,
                career: values.career,
                clinicalHistory: values.clinicalHistory,
                gender: values.gender.name,
                identification: values.identification,
                identificationTypeId: values.identificationTypeId.id,
                nationality: values.nationality,
                birthdate: birthdate,
                episodes: episodesResult //listEpisodes
            };
            savePatient(valuesSave);
        }
    });

    useEffect(() => {
        //reset()
        if (editMode) {
            setFieldValue('name', patientInfo.name, { isTouched: false });
            setFieldValue(
                'identificationTypeId',
                getTypeDocs(patientInfo.identificationTypeId),
                { isTouched: false }
            );
            setFieldValue('identification', patientInfo.identification, { isTouched: false });
            setFieldValue('gender', getTypeGender(patientInfo.gender), { isTouched: false });
            setFieldValue('career', patientInfo.career, { isTouched: false });
            setFieldValue('nationality', patientInfo.nationality, { isTouched: false });
            setFieldValue('clinicalHistory', patientInfo.clinicalHistory, { isTouched: false });

            /* if (isDefined(patientInfo.episodes)) {
                for (let i = 0; i < patientInfo.episodes.length; i++) {
                    setFieldValue(
                        'episodes[' + i + '].type',
                        getTypeEpisode(patientInfo.episodes[i].type),
                        { isTouched: false }
                    );
                    setFieldValue(
                        'episodes[' + i + '].description',
                        patientInfo.episodes[i].description,
                        { isTouched: false }
                    );
                    setFieldValue(
                        'episodes[' + i + '].room',
                        patientInfo.episodes[i].room,
                        { isTouched: false }
                    );
                    setFieldValue(
                        'episodes[' + i + '].bed',
                        patientInfo.episodes[i].bed,
                        { isTouched: false }
                    );
                }
            } */
        }
    }, [editMode, isLoading, saveInProgress]);

    const closeShow = () => {
        onClose(isTouched);
    };

    const deleteEpisode = (episode: IEpisodes) => (value: any) => {

        let idInt = episode.idIntern || 0
        onDeleteEpisode(episode.id, idInt)
    }

    const [image, setImage] = useState({ preview: '', raw: '' });
    const [changePhoto, setChangePhoto] = useState({ change: false });
    const handleChangePhoto = (e: any) => {
        if (e.target.files[0] !== undefined) {
            setImage({
                preview: URL.createObjectURL(e.target.files[0]),
                raw: e.target.files[0]
            });
            setChangePhoto({ change: true });
        } else {
            setImage({
                preview: '',
                raw: ''
            });
        }
    };

    const [addField, setAddField] = useState({ type: '', description: '' });
    const onChangeField = (v: any) => {
        if (isDefined(v)) {
            if (isDefined(v.type)) {
                if (v.type != '') {
                    setAddField({
                        type: v.type,
                        description: v.type
                    });
                } else {
                    setAddField({
                        type: '',
                        description: ''
                    });
                }
            } else {
                if (v.name.startsWith('Int') || v.name.startsWith('Hosp')) {
                    setAddField({
                        type: 'inPatient',
                        description: 'inPatient'
                    });
                } else if (v.name !== '') {
                    setAddField({
                        type: 'outPatient',
                        description: 'outPatient'
                    });
                } else {
                    setAddField({
                        type: '',
                        description: ''
                    });
                }
            }
        } else {
            setAddField({
                type: '',
                description: ''
            });
        }
    };

    const onClickAddButton = (e: any) => {
        if (isDefined(addField)) {
            if (addField.type !== '') {
                onAddEpisodeToPatient(addField);
            }
        }
    };

    const handleEntryDateEpisodeChange = (idepisode: number) => (value: any) => {
        if (isDefined(value)) {
            setChangeDates(true);
            onChangeEpisodesDate('entry', idepisode, value);
        }
    };

    const handleExitDateEpisodeChange = (idepisode: number) => (value: any) => {
        setChangeDates(true);
        onChangeEpisodesDate('exit', idepisode, value);
    };

    const [birthdate, setBirthDate] = useState(patientInfo.birthDate);
    const [changeDates, setChangeDates] = useState(false);
    const handleDateChange = (v: any) => {
        if (isDefined(v)) {
            setBirthDate(v);
            setChangeDates(true);
        } else {
            //min date
            /* this.setState({
                            dateFromReport: isDefined(this.props.woundInfo.minDateFromReport) ? moment(this.props.woundInfo.minDateFromReport).format("YYYY/MM/DD") : null
                        }) */
            //setBirthDate(null);
        }
    };

    //const typesDocs = [{ id: 2, description: "SNS", name: "SNS" }, { id: 4, description: "CESD", name: "CESD" }, { id: 6, description: "CC", name: "CC" }, { id: 7, description: "NIF", name: "NIF" }]
    let typesDocs = [{ id: 2, description: 'SNS', name: 'SNS' }];

    for (let i = 0; i < identificationTypes.length; i++) {
        let newType = {
            id: identificationTypes[i].id,
            description: identificationTypes[i].type,
            name: identificationTypes[i].type
        };
        if (i == 0) {
            typesDocs = [newType];
        } else {
            typesDocs = typesDocs.concat(newType);
        }
    }

    const getTypeDocs = (value: number) => {
        let typeDoc = null;

        for (let i = 0; i < typesDocs.length; i++) {
            if (typesDocs[i].id === value) {
                typeDoc = typesDocs[i];
                break;
            }
        }

        return typeDoc;
    };

    const typesGender = [
        { id: 1, description: t('Patient.Male'), name: t('Patient.Male') },
        { id: 2, description: t('Patient.Female'), name: t('Patient.Female') }
    ];

    const getTypeGender = (value: string) => {
        let gender;

        if (value == '') {
            gender = null;
        } else if (value.startsWith('F') || value.startsWith('f')) {
            gender = typesGender[1];
        } else {
            gender = typesGender[0];
        }
        return gender;
    };
    var language = localStorage.getItem('i18nextLng') || 'pt';
    if (language.length > 2) {
        language = language.substr(0, 2).toUpperCase();
    }

    let listEpisodes = patientInfo.episodes || [];
    const episodesTypes = [
        {
            id: 1,
            description: t('Hospitalisation'),
            name: t('Hospitalisation'),
            type: 'inPatient'
        },
        { id: 2, description: t('External'), name: t('External'), type: 'outPatient' }
    ];
    const getTypeEpisode = (value: string) => {
        let result;

        if (value.startsWith('out')) {
            result = episodesTypes[1];
        } else if (value.startsWith('in')) {
            result = episodesTypes[0];
        } else {
            result = null;
        }
        return result;
    };

    let haveOpenEpisodes = false;
    let haveOpenEpisodesInt = false;
    let haveEpisodes = false;
    for (let i = 0; i < listEpisodes.length; i++) {
        let ep = listEpisodes[i];
        if (!ep.delete) {
            haveEpisodes = true;
            if (!isDefined(ep.exitDate)) {
                if (ep.type == 'outPatient') {
                    haveOpenEpisodes = true;
                } else if (ep.type == 'inPatient') {
                    haveOpenEpisodesInt = true;
                }
                if (haveOpenEpisodes && haveOpenEpisodesInt) {
                    break;
                }
            }
        }
    }

    let haveTwoEpisodesOpen = false;
    if (haveOpenEpisodes || haveOpenEpisodesInt) {
        for (let i = 0; i < listEpisodes.length; i++) {
            let ep = listEpisodes[i];
            if (!ep.delete) {
                if (!isDefined(ep.exitDate)) {
                    for (let j = 0; j < listEpisodes.length; j++) {
                        if (i !== j) {
                            let ep2 = listEpisodes[j];
                            if (!ep2.delete) {
                                if (ep2.type == ep.type && !isDefined(ep2.exitDate)) {
                                    haveTwoEpisodesOpen = true;
                                    break;
                                }
                            }
                        }
                    }
                    if (haveTwoEpisodesOpen) {
                        break;
                    }
                }
            }
        }
    }

    return (
        <Form id='form-patient-add' autocomplete='off' className='form-dialog'>
            <DialogTitle
                className='main-shadow edit-add-patient-title'
                disableTypography={true}
            >
                <IconButton
                    color='primary'
                    className='float-right outline-none'
                    onClick={closeShow}
                    centerRipple
                >
                    <CloseIcon className='my-auto' fontSize='large' />
                </IconButton>

                <IconButton
                    color='primary'
                    className='float-right outline-none'
                    type='submit'
                    disabled={
                        saveInProgress
                            ? true
                            : changePhoto.change
                                ? false
                                : changeDates
                                    ? !(canSubmit && isValid && !haveTwoEpisodesOpen && haveEpisodes)
                                    : !(isTouched && canSubmit && isValid && !haveTwoEpisodesOpen && haveEpisodes)
                    }
                    centerRipple
                >
                    <SaveIcon className='my-auto' fontSize='large' />
                </IconButton>

                <Box
                    fontFamily='Nunito'
                    fontSize={20}
                    fontWeight={700}
                    className='text-uppercase mt-3 add-and-edit-title'
                >
                    {editMode ? t('EditPatient') : t('AddPatient')}
                </Box>
            </DialogTitle>

            <DialogContent dividers={true}>
                <div className='px-0 pl-md-5'>
                    <LoadingModal hidden={!isLoading} />
                    <Container className='px-0'>
                        <Row noGutters>
                            <Col sm={12} md={4} lg={3} className='pr-0 pr-md-5 text-center px-0'>
                                <div className='container-photo-user mx-auto'>
                                    <Image
                                        className={
                                            'photo-user fit-photo' +
                                            (image.preview !== ''
                                                ? ' border-photo-user'
                                                : patientInfo.photoUri === '' || patientInfo.photoUri == null
                                                    ? ''
                                                    : ' border-photo-user')
                                        }
                                        roundedCircle
                                        src={
                                            image.preview !== ''
                                                ? image.preview
                                                : patientInfo.photoUri === '' || patientInfo.photoUri == null
                                                    ? PatientIcon
                                                    : patientInfo.photoUri
                                        }
                                    //onError={(event) => {event.target.src = PatientIcon; event.className = 'photo-user'}}
                                    ></Image>

                                    <IconButton
                                        className='add-photo-user position-relative outline-none'
                                        size='small'
                                        color='primary'
                                        aria-label='f3m'
                                        hidden={isLoading}
                                    >
                                        <label htmlFor='fileinputPatient'>
                                            <AddAPhotoIcon className='white-color'></AddAPhotoIcon>
                                        </label>
                                    </IconButton>
                                    <input
                                        id='fileinputPatient'
                                        type='file'
                                        accept='.gif,.jpg,.jpeg,.png'
                                        style={{ display: 'none' }}
                                        onChange={handleChangePhoto}
                                    />
                                </div>
                            </Col>

                            {/* Este TextField está aqui, display = none, para que o formulário (no chrome) aceite o autocomplete=off e não preencha os valores por omissão */}
                            <TextField style={{ display: 'none' }} name='dummy'></TextField>

                            <Col sm={12} md={8} lg={9} className='px-0 pr-md-4 pl-0 pl-md-4 pl-lg-0'>
                                <FeedbackInput
                                    id={'mpdsAdduserName'}
                                    label={t('Name')}
                                    required
                                    field='name'
                                    customClasses='w-100 pb-4 pl-md-0'
                                    autocomplete={false}
                                    shrink
                                    defaultValue={patientInfo.name}
                                    customInputClasses='pb-1 pr-5'
                                    customLabelClasses='label-font-size ml-4 ml-md-0'
                                    disabled={isLoading}
                                />

                                <Container className='px-0'>
                                    <Row>
                                        <Col sm={12} md={6}>
                                            <FeedbackAutocomplete
                                                id={'combo-box-tipoDoc'}
                                                field={'identificationTypeId'}
                                                classesLabel={'label-font-size labelMarginFix '}
                                                options={typesDocs}
                                                label={t('Patient.TypeDoc')}
                                                defaultValue={getTypeDocs(patientInfo.identificationTypeId)}
                                                includeInputInList={false}
                                                required={true}
                                                disabled={isLoading}
                                                noOptionsText={t('NoOptions')}
                                                customClasses='w-100 pb-4 pb-md-4 px-md-0'
                                                classesTextfield='pb-0 pb-md-0'
                                            />
                                        </Col>
                                        <Col sm={12} md={6}>
                                            <FeedbackInput
                                                id={'mpdsPatientDocIdentification'}
                                                label={t('Patient.Doc')}
                                                field='identification'
                                                customClasses='w-100 pb-4 pb-md-4 px-md-0'
                                                autocomplete={false}
                                                shrink
                                                defaultValue={patientInfo.identification}
                                                customLabelClasses='label-font-size'
                                                disabled={isLoading}
                                                required={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} md={6}>
                                            <MuiPickersUtilsProvider
                                                utils={DateFnsUtils}
                                                locale={language === 'PT' ? pt : enGB}
                                            >
                                                <DateCalendarField
                                                    id='birthDate'
                                                    labelText={t('Patient.BirthDate')}
                                                    inputLabelProps={{
                                                        shrink: true,
                                                        className: 'label-font-size'
                                                    }}
                                                    class='w-100 pb-4 pb-md-4 px-md-0'
                                                    onChangeInput={handleDateChange}
                                                    invalidDateMessage={t('invalidDateFormat')}
                                                    required={true}
                                                    valueInput={birthdate}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Col>
                                        <Col sm={12} md={6}>
                                            <FeedbackAutocomplete
                                                id={'combo-box-gender'}
                                                field={'gender'}
                                                options={typesGender}
                                                label={t('Patient.Gender')}
                                                defaultValue={getTypeGender(patientInfo.gender)}
                                                classesLabel={`labelMarginFix label-font-size`}
                                                includeInputInList={false}
                                                required={true}
                                                disabled={isLoading}
                                                noOptionsText={t('NoOptions')}
                                                customClasses='w-100 pb-4 pb-md-4 px-md-0'
                                                classesTextfield='pb-0 pb-md-0'
                                            />
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        </Row>

                        <Row className='pr-0 pr-md-4 pt-0 pt-md-3'>
                            <Col sm={12} md={6} lg={6}>
                                <FeedbackInput
                                    id={'mpdsAdduserSpeciality'}
                                    label={t('Patient.Nationality')}
                                    field='nationality'
                                    required
                                    customClasses='w-100 pb-4'
                                    autocomplete={false}
                                    shrink
                                    defaultValue={patientInfo.nationality}
                                    customInputClasses='pb-1'
                                    customLabelClasses='label-font-size'
                                    disabled={isLoading}
                                />
                            </Col>
                            <Col sm={12} md={6} lg={6}>
                                <FeedbackInput
                                    id={'mpdsAddpatientCareer'}
                                    label={t('Patient.Career')}
                                    field='career'
                                    customClasses='w-100 pb-4'
                                    autocomplete={false}
                                    shrink
                                    defaultValue={patientInfo.career}
                                    customInputClasses='pb-1'
                                    customLabelClasses='label-font-size'
                                    disabled={isLoading}
                                />
                            </Col>
                        </Row>
                    </Container>
                    {/* <TextField
                        id={'mpdsClinicalHistory'}
                        label={t('Patient.ClinicalHistory')}
                        defaultValue={patientInfo.clinicalHistory}
                        variant='outlined'
                        multiline={true}
                        disabled={isLoading}
                        className='w-100 mt-2 pr-0 pr-md-4'
                        InputLabelProps={{ shrink: true, className: 'label-font-size' }}

                    /> */}
                    <FeedbackInput
                        id={'mpdsClinicalHistory'}
                        label={t('Patient.ClinicalHistory')}
                        field='clinicalHistory'
                        customClasses='w-100 mt-2 pr-0 pr-md-4'
                        autocomplete={false}
                        shrink
                        defaultValue={patientInfo.clinicalHistory}
                        customLabelClasses='label-font-size ml-4 ml-md-0'
                        disabled={isLoading}
                        multiline={true}
                        variant={'outlined'}
                    />
                    <hr className='mr-0 mr-md-4' />

                    <Typography variant='subtitle2' className='text-uppercase pb-2' gutterBottom>
                        {t('Episodes')}
                    </Typography>

                    <Container className='px-0'>
                        <Row hidden={!editMode} className='pr-0 pr-md-4'>
                            <Col xs={10} md={4} className='pb-4'>
                                <FeedbackAutocomplete
                                    id={'combo-box-episodes-new'}
                                    field={'episodes[' + listEpisodes.length + '].type'}
                                    options={episodesTypes}
                                    label={t('Type')}
                                    defaultValue={{ id: 0, description: '', name: '' }}
                                    onChangeField={(v) => onChangeField(v)}
                                    includeInputInList={false}
                                    classesLabel={`label-font-size labelMarginFix `}
                                    variantAutocomplete='filled'
                                    //required={listEpisodes.length === 0}
                                    disabled={isLoading}
                                    noOptionsText={t('NoOptions')}
                                />
                            </Col>
                            <Col xs={2} md={3} className='my-auto pb-1 pr-md-5 pl-md-4 px-0'>
                                <Button
                                    className='btn-add-episode'
                                    id='buttonAddEpisode'
                                    color='primary'
                                    variant='contained'
                                    onClick={onClickAddButton}
                                    disabled={
                                        addField.type === '' ||
                                        (addField.type === 'outPatient' && haveOpenEpisodes) ||
                                        (addField.type === 'inPatient' && haveOpenEpisodesInt)
                                    }
                                >
                                    <AddIcon></AddIcon>
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                    {listEpisodes.map((episode, index) => (episode.id == 0 ?
                        <>
                            <hr className={`${classes.hrEpisodes} mr-0 mr-md-4`} hidden={!editMode} />
                            <Container className='px-0'>
                                <Row key={'episr1' + index + episode.id} className='pr-0 pr-md-4'>
                                    <Col xs={12} md={3} className='pb-4'>
                                        <FeedbackAutocomplete
                                            id={'combo-box-episodes' + index + episode.id}
                                            field={'episodes[' + index + '].type'}
                                            classesLabel={`label-font-size labelMarginFix`}
                                            customClasses='w-100'
                                            classesTextfield='pb-0 pb-md-0'
                                            options={episodesTypes}
                                            label={t('Type')}
                                            defaultValue={getTypeEpisode(episode.type)}
                                            includeInputInList={false}
                                            required={true}
                                            disabled={isLoading || episode.id > 0}
                                            noOptionsText={t('NoOptions')}
                                            onChangeField={(v) => onChangeField(v)}
                                        />
                                    </Col>
                                    <Col xs={12} md={9} className='pb-4'>
                                        <FeedbackInput
                                            id={'episodeReason' + index + episode.id}
                                            label={t('Reason')}
                                            field={'episodes[' + index + '].description'}
                                            required
                                            customClasses='w-100'
                                            autocomplete={false}
                                            shrink
                                            defaultValue={episode.description}
                                            customInputClasses='pr-0 pr-md-5'
                                            customLabelClasses='label-font-size ml-0'
                                            disabled={isLoading}
                                        />
                                    </Col>
                                </Row>
                                <Row key={'episr2' + index} className='pr-0 pr-md-4'>
                                    <Col xs={12} md={3} className='pb-4'>
                                        <MuiPickersUtilsProvider
                                            utils={DateFnsUtils}
                                            locale={language === 'PT' ? pt : enGB}
                                        >
                                            <DateCalendarField
                                                id={'entryDate' + index + episode.id}
                                                labelText={t('EntryDate')}
                                                inputLabelProps={{ shrink: true, className: 'label-font-size' }}
                                                valueInput={episode.entrydate}
                                                onChangeInput={handleEntryDateEpisodeChange(episode.id)}
                                                class='w-100'
                                                //minDate={this.state.minDateFromReport}
                                                //maxDate={this.state.maxDateToReport}
                                                invalidDateMessage={t('invalidDateFormat')}
                                                required={true}
                                            //field='birthdate'
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                    <Col xs={12} md={3} lg={3} className='pb-4'>
                                        <MuiPickersUtilsProvider
                                            utils={DateFnsUtils}
                                            locale={language === 'PT' ? pt : enGB}
                                        >
                                            <DateCalendarField
                                                id={'exitDate' + index + episode.id}
                                                labelText={t('ExitDate')}
                                                inputLabelProps={{
                                                    shrink: true,
                                                    className: 'label-font-size'
                                                }}
                                                valueInput={episode.exitDate}
                                                onChangeInput={handleExitDateEpisodeChange(episode.id)}
                                                class='w-100'
                                                minDate={episode.entrydate}
                                                maxDate={moment().format('YYYY-MM-DD')}
                                                invalidDateMessage={t('invalidDateFormat')}
                                            //required={true}
                                            //field='birthdate'
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                    <Col
                                        xs={12}
                                        md={3}
                                        className='pb-4'
                                        hidden={
                                            (editMode && episode.type != 'inPatient') ||
                                            (!editMode && addField.type != 'inPatient')
                                        }
                                    >
                                        <FeedbackInput
                                            id={'room' + index + episode.id}
                                            label={t('WoundsGrid.Room')}
                                            field={'episodes[' + index + '].room'}
                                            required={
                                                (editMode && episode.type == 'inPatient') ||
                                                (!editMode && addField.type == 'inPatient')
                                            }
                                            customClasses='w-100'
                                            autocomplete={false}
                                            shrink
                                            defaultValue={episode.room}
                                            customLabelClasses='label-font-size'
                                            disabled={isLoading}
                                        />
                                    </Col>
                                    <Col
                                        xs={12}
                                        md={3}
                                        className='pb-4'
                                        hidden={
                                            (editMode && episode.type != 'inPatient') ||
                                            (!editMode && addField.type != 'inPatient')
                                        }
                                    >
                                        <FeedbackInput
                                            id={'bed' + index + episode.id}
                                            label={t('WoundsGrid.Bed')}
                                            field={'episodes[' + index + '].bed'}
                                            required={
                                                (editMode && episode.type == 'inPatient') ||
                                                (!editMode && addField.type == 'inPatient')
                                            }
                                            customClasses='w-100'
                                            autocomplete={false}
                                            shrink
                                            defaultValue={episode.bed}
                                            customLabelClasses='label-font-size'
                                            disabled={isLoading}
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </>
                        : <></>))}
                    {listEpisodes.map((episode, index) => (episode.id > 0 ?
                        <>
                            <hr className={`${classes.hrEpisodes} mr-0 mr-md-4`} hidden={!editMode || episode.delete} />
                            <Container className='px-0' hidden={episode.delete}>
                                <Row key={'episr1' + index + episode.id} className='pr-0 pr-md-4'>
                                    <Col xs={9} md={3} className='pb-4 col-ep-1'>
                                        <FeedbackAutocomplete
                                            id={'combo-box-episodes' + index + episode.id}
                                            field={'episodes[' + index + '].type'}
                                            classesLabel={`label-font-size labelMarginFix`}
                                            customClasses='w-100'
                                            classesTextfield='pb-0 pb-md-0'
                                            options={episodesTypes}
                                            label={t('Type')}
                                            defaultValue={getTypeEpisode(episode.type)}
                                            includeInputInList={false}
                                            required={true}
                                            disabled={isLoading || episode.id > 0}
                                            noOptionsText={t('NoOptions')}
                                            onChangeField={(v) => onChangeField(v)}
                                        />
                                    </Col>
                                    <Col xs={12} md={8} className='pb-4 col-ep-2'>
                                        <FeedbackInput
                                            id={'episodeReason' + index + episode.id}
                                            label={t('Reason')}
                                            field={'episodes[' + index + '].description'}
                                            required
                                            customClasses='w-100'
                                            autocomplete={false}
                                            shrink
                                            defaultValue={episode.description}
                                            customInputClasses='pr-0 pr-md-5'
                                            customLabelClasses='label-font-size ml-0'
                                            disabled={isLoading}
                                        />

                                    </Col>
                                    <Col xs={3} md={1} className='pb-4 col-ep-3'>
                                        <IconButton
                                            color='primary'
                                            className='outline-none'
                                            onClick={deleteEpisode(episode)}
                                            disabled={false}
                                            centerRipple
                                        >
                                            <DeleteIcon className='my-auto' fontSize='large' />
                                        </IconButton>
                                    </Col>
                                </Row>
                                <Row key={'episr2' + index} className='pr-0 pr-md-4'>
                                    <Col xs={12} md={3} className='pb-4'>
                                        <MuiPickersUtilsProvider
                                            utils={DateFnsUtils}
                                            locale={language === 'PT' ? pt : enGB}
                                        >
                                            <DateCalendarField
                                                id={'entryDate' + index + episode.id}
                                                labelText={t('EntryDate')}
                                                inputLabelProps={{ shrink: true, className: 'label-font-size' }}
                                                valueInput={episode.entrydate}
                                                onChangeInput={handleEntryDateEpisodeChange(episode.id)}
                                                class='w-100'
                                                //minDate={this.state.minDateFromReport}
                                                //maxDate={this.state.maxDateToReport}
                                                invalidDateMessage={t('invalidDateFormat')}
                                                required={true}
                                            //field='birthdate'
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                    <Col xs={12} md={3} lg={3} className='pb-4'>
                                        <MuiPickersUtilsProvider
                                            utils={DateFnsUtils}
                                            locale={language === 'PT' ? pt : enGB}
                                        >
                                            <DateCalendarField
                                                id={'exitDate' + index + episode.id}
                                                labelText={t('ExitDate')}
                                                inputLabelProps={{
                                                    shrink: true,
                                                    className: 'label-font-size'
                                                }}
                                                valueInput={episode.exitDate}
                                                onChangeInput={handleExitDateEpisodeChange(episode.id)}
                                                class='w-100'
                                                minDate={episode.entrydate}
                                                maxDate={moment().format('YYYY-MM-DD')}
                                                invalidDateMessage={t('invalidDateFormat')}
                                            //required={true}
                                            //field='birthdate'
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                    <Col
                                        xs={12}
                                        md={3}
                                        className='pb-4'
                                        hidden={
                                            (editMode && episode.type != 'inPatient') ||
                                            (!editMode && addField.type != 'inPatient')
                                        }
                                    >
                                        <FeedbackInput
                                            id={'room' + index + episode.id}
                                            label={t('WoundsGrid.Room')}
                                            field={'episodes[' + index + '].room'}
                                            required={
                                                (editMode && episode.type == 'inPatient') ||
                                                (!editMode && addField.type == 'inPatient')
                                            }
                                            customClasses='w-100'
                                            autocomplete={false}
                                            shrink
                                            defaultValue={episode.room}
                                            customLabelClasses='label-font-size'
                                            disabled={isLoading}
                                        />
                                    </Col>
                                    <Col
                                        xs={12}
                                        md={3}
                                        className='pb-4'
                                        hidden={
                                            (editMode && episode.type != 'inPatient') ||
                                            (!editMode && addField.type != 'inPatient')
                                        }
                                    >
                                        <FeedbackInput
                                            id={'bed' + index + episode.id}
                                            label={t('WoundsGrid.Bed')}
                                            field={'episodes[' + index + '].bed'}
                                            required={
                                                (editMode && episode.type == 'inPatient') ||
                                                (!editMode && addField.type == 'inPatient')
                                            }
                                            customClasses='w-100'
                                            autocomplete={false}
                                            shrink
                                            defaultValue={episode.bed}
                                            customLabelClasses='label-font-size'
                                            disabled={isLoading}
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </>
                        : <></>))}
                </div>
            </DialogContent>
        </Form>
    );
};

export default PatientsInfoForm;
